<template>
  <div class="commodityMarketView">
    <vxe-table
      border
      :auto-resize="true"
      show-overflow
      size="mini"
      ref="xTable"
      :edit-rules="validRules"
      :data="commodityMarketDatas"
      :valid-config="{ autoPos: true, message: 'inline' }"
      :edit-config="{ trigger: 'click', mode: 'row', showStatus: true }"
    >
      <vxe-table-column
        type="index"
        :title="$t('personnel.table.index')"
        width="50"
      ></vxe-table-column>
      <vxe-table-column
        field="preNo"
        :title="$t('logistics.commodityMarket.shippingInstructionNo')"
        width="180"
        v-if="upstreamTypes == 1"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <span>{{ scope.row.preNo }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="preDetailNo"
        :title="$t('logistics.commodityMarket.instructionDetailNo')"
        width="180"
        v-if="upstreamTypes == 1"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <span>{{ scope.row.preDetailNo }}</span>
        </template>
        <template v-slot="{ row }">{{ row.preDetailNo }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="preNo"
        :title="$t('logistics.commodityMarket.returnExchangeNo')"
        width="180"
        v-if="upstreamTypes == 2 || upstreamTypes == 3"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <span>{{ scope.row.preNo }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="preDetailNo"
        :title="$t('logistics.commodityMarket.returnExchangeRowNo')"
        width="180"
        v-if="upstreamTypes == 2 || upstreamTypes == 3"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <span>{{ scope.row.preDetailNo }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="preNo"
        :title="$t('logistics.commodityMarket.inventoryAllocationNo')"
        width="180"
        v-if="upstreamTypes == 4"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <span>{{ scope.row.preNo }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="preDetailNo"
        :title="$t('logistics.commodityMarket.inventoryAllocationRowNo')"
        width="180"
        v-if="upstreamTypes == 4"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <span>{{ scope.row.preDetailNo }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="productNo"
        :title="$t('logistics.commodityMarket.productNo')"
        width="180"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <span>{{ scope.row.productNo }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="productName"
        :title="$t('logistics.commodityMarket.productName')"
        width="180"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <span>{{ scope.row.productName }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="partnerName"
        :title="$t('logistics.commodityMarket.shippingName')"
        width="180"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <span>{{ scope.row.partnerName }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="distributionBatchNo"
        :title="$t('logistics.commodityMarket.distributionBatchNo')"
        width="180"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-input
            v-model="scope.row.distributionBatchNo"
            clearable
            @input="$refs.xTable.updateStatus(scope)"
          ></el-input>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="instructionNumber"
        :title="$t('logistics.commodityMarket.instructionNumber')"
        width="180"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <span>{{
            $baseRequest.formatTableColumn(scope.row.instructionNumber, $globalVar.qPoint)
          }}</span>
        </template>
        <template v-slot="{ row }">{{
          $baseRequest.formatTableColumn(row.instructionNumber, $globalVar.qPoint)
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="inboundQuantity"
        :title="$t('logistics.commodityMarket.inboundQuantity')"
        width="180"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <!-- sxp 物流入库数量进行校验，不得超过剩余应入数量（∑发货指令下物流入库数量≤发货指令数量）
               剩余应入数量=供应商发货指令数量-∑该供应商发货指令下物流入库单入库数量
               （目前剩余应入数量已设计了计算逻辑，以上公式供检查及核对用，若目前逻辑无误则可不做修改） -->
          <input-number-ad
            v-model="scope.row.inboundQuantity"
            max="9999999999999"
            :precision="$globalVar.qPoint"
            :clearable="true"
            @input="(val) => inboundQuantityChange(scope, val)"
          >
          </input-number-ad>
        </template>
        <template v-slot="{ row }">{{
          $baseRequest.formatTableColumn(row.inboundQuantity, $globalVar.qPoint)
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="inboundNumLogisticsRemaining"
        :title="$t('logistics.searchTable.remainingQuantityIn')"
        width="100"
      >
        <template v-slot="{ row }">{{
          $baseRequest.formatTableColumn(row.inboundNumLogisticsRemaining, $globalVar.qPoint)
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="inboundUnit"
        :title="$t('logistics.commodityMarket.inboundUnit')"
        width="180"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.inboundUnit"
            filterable
            disabled
            clearable
            @change="$refs.xTable.updateStatus(scope)"
          >
            <el-option
              v-for="item in inboundUnitList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{ getSelectLabel(row.inboundUnit, inboundUnitList) }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="purchaseNo"
        :title="$t('logistics.commodityMarket.purchaseNo')"
        width="180"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <span>{{ scope.row.purchaseNo }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="puchaseDetailNo"
        :title="$t('logistics.commodityMarket.puchaseDetailNo')"
        width="180"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <span>{{ scope.row.puchaseDetailNo }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="packaging"
        :title="$t('logistics.commodityMarket.packaging')"
        width="180"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-input
            v-model="scope.row.packaging"
            clearable
            @input="$refs.xTable.updateStatus(scope)"
          ></el-input>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="unitWeight"
        :title="$t('logistics.commodityMarket.unitWeight')"
        width="180"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <input-number-ad
            v-model="scope.row.unitWeight"
            :max="99999999999.999999"
            :precision="$globalVar.qPoint"
            :clearable="true"
            @input="$refs.xTable.updateStatus(scope)"
          >
          </input-number-ad>
        </template>
        <template v-slot="{ row }">{{
          $baseRequest.formatTableColumn(row.unitWeight, $globalVar.qPoint)
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="unitNumber"
        :title="$t('logistics.commodityMarket.unitNumber')"
        width="180"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <input-number-ad
            v-model="scope.row.unitNumber"
            :max="999999999.999999"
            :precision="$globalVar.qPoint"
            :clearable="true"
            @input="$refs.xTable.updateStatus(scope)"
          >
          </input-number-ad>
        </template>
        <template v-slot="{ row }">{{
          $baseRequest.formatTableColumn(row.unitNumber, $globalVar.qPoint)
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="packagingNumber"
        :title="$t('logistics.commodityMarket.packagingNumber')"
        width="180"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <input-number-ad
            v-model="scope.row.packagingNumber"
            :max="999999999.999999"
            :precision="$globalVar.qPoint"
            :clearable="true"
            @input="$refs.xTable.updateStatus(scope)"
          >
          </input-number-ad>
        </template>
        <template v-slot="{ row }">{{
          $baseRequest.formatTableColumn(row.packagingNumber, $globalVar.qPoint)
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="packagingUnit"
        :title="$t('logistics.commodityMarket.packagingUnit')"
        width="180"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.packagingUnit"
            filterable
            clearable
            @change="$refs.xTable.updateStatus(scope)"
          >
            <el-option
              v-for="item in inboundUnitList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
        <template v-slot="{ row }">{{
          getSelectLabel(row.packagingUnit, inboundUnitList)
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="storageName"
        :title="$t('logistics.commodityMarket.storageNo')"
        width="180"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <search-table
            v-model="scope.row['storageNo']"
            searchType="warehouse"
            :isMultiple="true"
            :currentValue="scope.row['storageName'] ? scope.row['storageName'] : ''"
            :checkRowKeys="scope.row['storageNo'] ? [scope.row['storageNo']] : []"
            @input="(val) => chooseTableS(val, scope.row)"
            :disabled="true"
          ></search-table>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="productMark"
        :title="$t('logistics.commodityMarket.productMark')"
        width="180"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-input
            v-model="scope.row.productMark"
            clearable
            @input="$refs.xTable.updateStatus(scope)"
          ></el-input>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="refundRate"
        :title="$t('logistics.commodityMarket.refundRate')"
        width="180"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <input-number-ad
            v-model="scope.row.refundRate"
            :max="100.0"
            :precision="$globalVar.tPoint"
            :clearable="true"
            @input="$refs.xTable.updateStatus(scope)"
          >
          </input-number-ad>
        </template>
        <template v-slot="{ row }">{{
          $baseRequest.formatTableColumn(row.refundRate, $globalVar.tPoint)
        }}</template>
      </vxe-table-column>
      <vxe-table-column
        field="refundAmount"
        :title="$t('logistics.commodityMarket.refundAmount')"
        width="180"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <input-number-ad
            v-model="scope.row.refundAmount"
            :max="99999999999.999999"
            :clearable="true"
            @input="$refs.xTable.updateStatus(scope)"
          >
          </input-number-ad>
        </template>
        <template v-slot="scope">
          {{ $baseRequest.formatTableColumn(scope.row.refundAmount || 0) }}
        </template>
      </vxe-table-column>
    </vxe-table>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  // import API from '@/api/logisticsCenter/logisticsReceiptList.js';
  // import BASE_API from '@/api/dataBase.js';
  import SearchTable from '@/components/form-item/search-table';
  import inputNumberAd from '@/components/form-item/input-number-advance';
  import XEUtils from 'xe-utils';
  export default {
    name: 'commodityMarketView',
    props: ['commodityMarketData', 'upstreamType'],
    components: {
      SearchTable,
      inputNumberAd,
    },
    data() {
      // const inboundQuantityValid = (rule, cellValue, callback, { row }) => {
      //   if (row.inboundQuantity > row.inboundNumLogisticsRemaining && this.upstreamType != 1) {
      //     callback(new Error('物流入库数量不能超过剩余应入数量'));
      //   } else if (!row.inboundQuantity) {
      //     callback(new Error(this.$t('logistics.commodityMarket.inboundQuantityValidRules')));
      //   } else {
      //     callback();
      //   }
      // };
      return {
        validRules: {
          inboundQuantity: [
            // { validator: inboundQuantityValid}
            {
              required: true,
              message: this.$t('logistics.commodityMarket.inboundQuantityValidRules'),
            },
          ],
          inboundUnit: [
            { required: true, message: this.$t('logistics.commodityMarket.inboundUnitValidRules') },
          ], //下拉
          // unitWeight:[
          //   { required: true, message:  this.$t('logistics.commodityMarket.unitWeightValidRules')},
          // ],//搜索选择框搜索选择框
          // packagingUnit:[
          //   { required: true, message:  this.$t('logistics.commodityMarket.packagingUnitValidRules')},
          // ],//搜索选择框
          storageNo: [
            { required: true, message: this.$t('logistics.commodityMarket.storageNoValidRules') },
          ], //搜索选择框
          productMark: [
            { min: 0, max: 500, message: this.$t('currenciesAndCalendar.rules.writeLength') },
          ],
        },
        commodityMarketDatas: [],
        // inboundUnitList:[],
        upstreamTypes: '',
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        //单位下拉1
        inboundUnitList() {
          return this.$baseRequest.getDictListByType('basic_unit');
        },
      }),
    },
    watch: {
      commodityMarketData() {
        console.log(this.commodityMarketData.length);
        if (this.commodityMarketData.length > 0) {
          this.commodityMarketDatas = JSON.parse(JSON.stringify(this.commodityMarketData));
          this.commodityMarketDatas.forEach((item) => {
            item.storageNoList = { deliverToStorageName: '', deliverToStorageNo: '' };
            item.storageNoList.deliverToStorageName = item.storageName;
            item.storageNoList.deliverToStorageNo = item.storageNo;
          });
        }
        return this.commodityMarketDatas;
      },
      upstreamType() {
        if (this.upstreamType != '') {
          this.upstreamTypes = this.upstreamType;
        }
        return this.upstreamTypes;
      },
    },
    mounted() {
      // this.getInboundUnitList();
    },
    methods: {
      inboundQuantityChange(scope, val) {
        scope.row.inboundQuantity = val;
        let fullData = this.$refs.xTable.getTableData().fullData;
        this.$refs.xTable.updateData(fullData);
      },
      getTableData() {
        return this.$refs.xTable.tableData;
      },
      chooseTableS(val, row) {
        this.commodityMarketDatas.forEach((item) => {
          if (item.id == row.id) {
            item.storageNo = val;
            item.storageName = val[0].storageName;
          }
        });
        // row.storageNo = val[0].storageNo
        // row.storageName = val[0].storageName
      },
      getSaveVal() {
        return this.commodityMarketDatas;
      },
      chooseTable(val) {
        this.commodityMarketDatas.forEach((item) => {
          if (item.id == val.id) {
            item.storageNo = val.storageName[0].storageNo;
            item.storageName = val.storageName[0].storageName;
          }
        });
      },
      //表格组件下拉框选择回调
      getSelectLabel(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      //校验
      fullValidEvent() {
        let formList = ['xTable'];
        let resultArr = [];
        let _self = this;
        function validates(formName) {
          let result = new Promise((resolve, reject) => {
            _self.$refs[formName].validate((valid) => {
              valid ? resolve() : reject();
            });
          });
          resultArr.push(result);
        }
        formList.forEach((item) => {
          validates(item); // 循环校验
        });
        this.commodityMarketDatas = this.$refs.xTable.getTableData().fullData;
        let childList = {
          commodityMarketData: this.commodityMarketDatas,
        };
        return Promise.all(resultArr)
          .then(() => {
            return childList;
          })
          .catch(() => {});
      },
      //获取单位
      // async getInboundUnitList() {
      //   let params = {
      //   };
      //   const selectStatus = await this.$axios.post(
      //     BASE_API.GET_PRODUCT_UNIT_LIST,
      //     params
      //   );
      //   if (selectStatus.data.code == 0) {
      //     this.inboundUnitList = selectStatus.data.data;
      //   }
      // }
    },
  };
</script>
<style lang="scss" scoped></style>
